export type AppEnvironment = "dev" | "staging" | "prod";
export type EnvironmentNotchLabel = "LOCAL" | "STAGING";
export type EnvironmentBrandVariant = "production" | "non-production";

export function resolveEnvironmentNotchLabel(
  appEnv: AppEnvironment | string | null | undefined,
  isLocalDev = false,
): EnvironmentNotchLabel | null {
  const normalizedEnv = appEnv?.trim().toLowerCase();

  if (normalizedEnv === "prod") return null;
  if (normalizedEnv === "staging") return "STAGING";
  if (normalizedEnv === "dev") return "LOCAL";
  if (!normalizedEnv && isLocalDev) return "LOCAL";

  return null;
}

export function resolveEnvironmentBrandVariant(
  appEnv: AppEnvironment | string | null | undefined,
  isLocalDev = false,
): EnvironmentBrandVariant {
  const normalizedEnv = appEnv?.trim().toLowerCase();

  if (normalizedEnv === "dev" || normalizedEnv === "staging") return "non-production";
  if (!normalizedEnv && isLocalDev) return "non-production";

  return "production";
}
